<template>
    <div class="export_box">
        <div class="export_btn" v-if="!imageUrl" >
            <p :class="['image', 'fs18 co_fff', {inActive: !isLogin}]" @click="downLoadImg()">生成图片</p>
            <p :class="['mail', 'fs18 co_fff', {inActive: !isLogin}]" @click="exportMail()">发送至邮箱</p>
        </div>
        <!--   下载图片     -->
        <section v-else id="downloadImg">
            <img :src="imageUrl" alt="">
            <p class="closeBtn fs32 co_fff text_c" @click="imageUrl = null;">x</p>
        </section>
        <alert :alertData="alertData" v-show="alertData.isAlert" @closeDialog="alertData.isAlert = false"/>
        <LoadingPage :loading="loading"/>

    </div>
</template>

<script>
import utils from "@/util/common";
import _ from "lodash";

export default {
    name: 'ExportButton',
    components: {
        Alert(render){ require(["@/components/common/Alert"], render) },
        LoadingPage(render){ require(["@/components/common/LoadingPage"], render) },

    },
    props: {
        page: String,
        startTime: String,
        endTime: String,
        subject: String,
    },
    data() {
        return {
            isLogin: false,
            imageUrl: null,
            loading: false,
            fileNameMap: {
                report: 'reportDetail',
                compare: 'companyCompared',
                rankList: 'rankList',
            },
            alertData: {
                title: '正在下载，请稍后…',
                message: "",
                subhead: "",
                isAlert: false,
                btnType: 'single', //   'single' | 'double' | 'none'
            },
        }
    },
    mounted() {
        sessionStorage.removeItem("sendEmailData");
        sessionStorage.removeItem("imageData");
        sessionStorage.removeItem("sendEmailPptData");
        this.isLogin = !!(utils.getCookie("xinhuaToken") || this.$route.query.xinhuaToken);
    },
    methods: {
        downLoadImg: async function () {
            this.loading = true;
            this.$emit('handelPptAndImageData');
            var intervalId = setInterval(() => {
                let imageData = sessionStorage.getItem('imageData')
                if(imageData){
                    let {data: pngBase64} = JSON.parse(imageData);
                    this.imageUrl = `${pngBase64}`;
                    this.alertData.title = '长按图片保存';
                    this.alertData.isAlert = true;
                    this.loading = false;
                    // sessionStorage.removeItem("imageData")
                    clearInterval(intervalId)
                }

            }, 600)
            // this.$router.push({path: `/export?page=${this.page}`});
        },
        exportMail: function () {
            this.loading = true;
            this.saveMailData();
            this.$emit('handelPptAndImageData');

            var intervalId = setInterval(() => {
                let emailPptData = sessionStorage.getItem(this.page === 'report' ? 'sendEmailPptData' : 'imageData')
                if(emailPptData){
                    clearInterval(intervalId);
                    this.loading = false;
                    this.$router.push({path: `/export?page=${this.page}`});
                }

            }, 600)

        },
        saveMailData: function () {
            let mailData = {
                id: this.$route.params.id,
                fileName: this.fileNameMap[this.page],
                subject: this.subject,
            }

            if (this.page === 'rankList') {
                let query = this.$route.query;
                mailData = {
                    ref: 'chief',
                    exportModule: "chiefRank",
                    subject: `${this.subject}`,
                    limitChiefCount: 10,//限制10条
                    query: _.assign(query, {sourceWeb: 'xinhua'}),
                }
            }
            sessionStorage.setItem('sendEmailData', JSON.stringify(mailData));
        }
    }
}
</script>

<style lang="scss" scoped>
.export_box {
    z-index: 2;

    .export_btn {
        display: flex;
        height: 48px;
        margin-top: 10px;

        p {
            width: 50%;
            text-align: center;
            line-height: 48px;
            font-family: PingFangSC-Medium;
            letter-spacing: 0;
            font-weight: 500;
        }

        .image {
            background: #F29E01;
        }

        .mail {
            background: #376CCF;
        }

        .image.inActive {
            background: #c9c9ca;
            pointer-events: none;
            border-right: 1px solid #fff;
        }

        .mail.inActive {
            background: #c9c9ca;
            pointer-events: none;
        }
    }
}

</style>